import SensorSettingPage from './sensor-setting-page';

export default SensorSettingPage;